import type { ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { Callout, type CalloutProps } from '@/components/ui/callout';

export type PickerStatusKind = 'hint' | 'ok' | 'near' | 'new' | 'error' | 'done';

const CALLOUT: Record<PickerStatusKind, Pick<CalloutProps, 'tone' | 'size' | 'icon'>> = {
  hint: { tone: 'neutral', size: 'inline' },
  ok: { tone: 'success', size: 'inline' },
  near: { tone: 'warning', size: 'box' },
  new: { tone: 'warning', size: 'box', icon: Plus },
  error: { tone: 'error', size: 'box' },
  done: { tone: 'success', size: 'box' },
};

/** The line under a picker (hint, confirmation, warning, refusal): the shared `Callout`. */
export function PickerStatus({
  kind,
  children,
  testId,
  id,
}: {
  kind: PickerStatusKind;
  children: ReactNode;
  testId?: string;
  id?: string;
}) {
  return (
    <Callout
      {...CALLOUT[kind]}
      id={id}
      data-testid={testId}
      role={kind === 'ok' ? null : undefined}
    >
      {children}
    </Callout>
  );
}
